export enum RefundMoneyRequestStatus {
  Created = 'created',
  Succeeded = 'succeeded',
  Canceled = 'canceled',
}

export interface IRejectBody {
  id: number
  reason: string|null
}

export interface IConfirmBody {
  id: number
}

export interface IResendNotificationBody {
  id: number
}

export interface IRefundMoneyRequest {
  id: number
  status: RefundMoneyRequestStatus
  policyNumber: string
  createdAt: string
  willBeRefundedOn: string
  amountRefunded: number
  payeeFullName: string
  payeeAccountNumber: string
  bankName: string
  bankIdentificationCode: string
  correspondentAccount: string
  completedAt: string|null
  cancellationReason: string|null
}